/* BioPulse mobile sticky add-to-cart bar. No dependencies.
   Shows the bar once the main buy button has scrolled above the viewport,
   hides it while the buy box is visible or near the footer. Single-variant
   products proxy the main form's submit button so cart drawer apps
   (UpCart) intercept normally; multi-variant products scroll to the
   variant picker instead. */
(function () {
  'use strict';

  if (customElements.get('bp-sticky-atc')) return;

  class BpStickyAtc extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode === 'choose' ? 'choose' : 'add';
      this.barButton = this.querySelector('.bp-sticky-atc__button');
      this.barLabel = this.querySelector('.bp-sticky-atc__button-label') || this.barButton;
      this.priceEl = this.querySelector('.bp-sticky-atc__price');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.productInfo = document.querySelector('product-info');
      this.form =
        document.querySelector('product-form form[data-type="add-to-cart-form"]') ||
        document.querySelector('form[action*="/cart/add"]');
      this.mainButton =
        (this.productInfo && this.productInfo.querySelector('button.product-form__submit')) ||
        (this.form && this.form.querySelector('button[type="submit"], button[name="add"]'));

      this.buyBoxAbove = false;
      this.buyBoxVisible = false;
      this.nearFooter = false;

      if (this.barButton) {
        this.handleClick = this.handleClick.bind(this);
        this.barButton.addEventListener('click', this.handleClick);
      }

      /* Scroll-driven state: IntersectionObserver misses instant jumps where
         isIntersecting stays false (below viewport to above viewport), so we
         compute from rects on a rAF-throttled scroll listener instead. */
      this.anchor = this.mainButton || this.form || this.productInfo;
      this.footer = document.querySelector('.footer') || document.querySelector('footer');
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.recompute();
          this.ticking = false;
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.recompute();

      this.syncFromMainButton();
      this.subscribeToVariantChanges();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.barButton && this.handleClick) {
        this.barButton.removeEventListener('click', this.handleClick);
      }
      if (typeof this.unsubscribeVariantChange === 'function') {
        this.unsubscribeVariantChange();
        this.unsubscribeVariantChange = null;
      }
    }

    recompute() {
      if (!this.anchor) return;
      const rect = this.anchor.getBoundingClientRect();
      this.buyBoxVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      this.buyBoxAbove = rect.bottom <= 0;
      if (this.footer) {
        const f = this.footer.getBoundingClientRect();
        this.nearFooter = f.top < window.innerHeight + 96;
      }
      this.update();
    }

    update() {
      const show = this.buyBoxAbove && !this.buyBoxVisible && !this.nearFooter;
      this.classList.toggle('bp-sticky-atc--visible', show);
    }

    handleClick(event) {
      event.preventDefault();
      if (this.mode === 'choose') {
        const picker =
          document.querySelector('variant-selects') ||
          document.querySelector('.product-form__input');
        if (picker) {
          picker.scrollIntoView({
            behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
            block: 'center'
          });
        }
        return;
      }
      if (this.mainButton && !this.mainButton.disabled) {
        this.mainButton.click();
      }
    }

    /* Mirror the main buy button's disabled state and label (Add to cart,
       Sold out, Unavailable) so the bar never disagrees with the page. */
    syncFromMainButton() {
      if (this.mode !== 'add' || !this.mainButton || !this.barButton) return;
      const disabled =
        this.mainButton.disabled ||
        this.mainButton.hasAttribute('disabled') ||
        this.mainButton.getAttribute('aria-disabled') === 'true';
      this.barButton.disabled = disabled;
      const span = this.mainButton.querySelector('span');
      const label = ((span || this.mainButton).textContent || '').trim();
      if (label) this.barLabel.textContent = label;
    }

    /* Read the freshly rendered main price (product-info updates its DOM
       before publishing variantChange), so formatting stays locale-correct. */
    syncPrice() {
      if (!this.priceEl || !this.productInfo) return;
      const onSale = this.productInfo.querySelector('.price--on-sale');
      const priceItem = onSale
        ? this.productInfo.querySelector('.price-item--sale')
        : this.productInfo.querySelector('.price-item--regular');
      const text = priceItem && priceItem.textContent ? priceItem.textContent.trim() : '';
      if (text) this.priceEl.textContent = text;
    }

    subscribeToVariantChanges() {
      try {
        const subscribeFn =
          typeof window.subscribe === 'function'
            ? window.subscribe
            : typeof subscribe === 'function'
              ? subscribe
              : null;
        const events =
          typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
        if (!subscribeFn || !events || !events.variantChange) return;
        this.unsubscribeVariantChange = subscribeFn(events.variantChange, () => {
          try {
            this.syncFromMainButton();
            this.syncPrice();
          } catch (error) {
            /* keep the bar usable even if a sync pass fails */
          }
        });
      } catch (error) {
        /* pubsub absent; the bar still works without live variant sync */
      }
    }
  }

  customElements.define('bp-sticky-atc', BpStickyAtc);
})();
